// @flow

import * as React from 'react';

import { useFormContext } from 'react-hook-form';

import { Text } from 'reshaped';

import { useTranslator } from '@gandi/translate';

import { Select } from 'src/Reshaped/Form/Select';

import { useQuote } from '../../hooks/useQuote';

export function SelectField(): React.MixedElement | null {
  const { __ } = useTranslator();

  const { control } = useFormContext();

  const { options, isPosting } = useQuote();

  if (!options.length) return null;

  return (
    <Select
      label={
        <Text variant="body-2" weight="bold">
          {__('Subscription period')}
        </Text>
      }
      name="duration"
      // $FlowFixMe[incompatible-type]
      options={options}
      control={control}
      help={__(
        'The duration specifies your subscription’s validity period and determines how long certificates will be issued and automatically renewed for the included domains',
      )}
      required
      selectProps={{ variant: 'faded' }}
      disabled={isPosting}
    />
  );
}
